<script setup>
// Dados a coletar (Fase 3, tela 02, spec §4.3): os atributos de contato marcados com polaris_collect. "O Polaris
// continua perguntando até saber; depois escolhe o desfecho." Gerenciar atributos vai para a tela de settings.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

// A página do Roteiro (pai) busca os atributos uma vez para as duas seções.
const { t } = useI18n();
const { accountScopedRoute } = useAccount();

const attributes = useMapGetter('attributes/getContactAttributes');

const collectable = computed(() =>
  (attributes.value || []).filter(item => item.polarisCollect)
);
</script>

<template>
  <section class="flex flex-col gap-3">
    <div class="flex items-center justify-between gap-2">
      <h2 class="m-0 text-base font-semibold text-polaris-foreground">
        {{ t('POLARIS.PLAYBOOK.DATA_TO_COLLECT.TITLE') }}
      </h2>
      <RouterLink
        :to="accountScopedRoute('attributes_list')"
        class="text-sm font-medium text-polaris-info-foreground hover:underline"
      >
        {{ t('POLARIS.PLAYBOOK.DATA_TO_COLLECT.MANAGE') }}
      </RouterLink>
    </div>
    <p class="m-0 text-sm text-polaris-muted-foreground">
      {{ t('POLARIS.PLAYBOOK.DATA_TO_COLLECT.DESCRIPTION') }}
    </p>
    <div
      v-if="collectable.length"
      class="rounded-polaris-lg border border-solid border-polaris-border bg-polaris-card"
    >
      <div
        v-for="attribute in collectable"
        :key="attribute.id"
        class="flex items-center justify-between gap-2 border-0 border-b border-solid border-polaris-border px-4 py-2.5 last:border-b-0"
      >
        <span class="text-sm font-medium text-polaris-foreground">
          {{ attribute.attributeDisplayName }}
        </span>
        <span class="text-xs text-polaris-muted-foreground">
          {{ attribute.attributeKey }}
        </span>
      </div>
    </div>
    <p v-else class="m-0 text-sm text-polaris-muted-foreground">
      {{ t('POLARIS.PLAYBOOK.DATA_TO_COLLECT.EMPTY') }}
    </p>
  </section>
</template>
